import React from 'react'
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom'

import SignIn from './pages/SignIn'
import Signout from './pages/Signout'

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/signin" element={<SignIn />} />
        <Route path="/signout" element={<Signout />} />
      </Routes>
    </Router>
  )
}

export default App
